import UgcTintImageControl from "./TintImageControl";

export default UgcTintImageControl;
